import { Table } from "react-bootstrap";
import swal from "sweetalert";
import {CgCopy} from "react-icons/cg";

export default function VideoDetails(props) {

    const reqData = props.data;
    const userData = props.userData;
    const celebData = props.celebData;

    return (
        <div className="bg-white/20 h-full w-full flex justify-center items-center">

            <Table bordered className="text-white table-fixed">
                <tbody>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                User
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {userData["fullName"]}
                            </div>
                        </td>
                        <td className="w-full flex justify-center items-center">
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(props.userId).then(function () {
                                        console.log('Async: Copying to clipboard was successful!');
                                    }, function (err) {
                                        console.error('Async: Could not copy text: ', err);
                                    });
                                    swal("Copied", "User ID was copied to the clipboard", "success");
                                }}
                                className="hover:scale-105 flex justify-center items-center">
                                <CgCopy size={40} color={"black"} className="bg-white p-2 rounded" />
                            </button>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Celebrity
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {celebData["fullName"]}
                            </div>
                        </td>

                        <td className="w-full">
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(props.celebId).then(function () {
                                        console.log('Async: Copying to clipboard was successful!');
                                    }, function (err) {
                                        console.error('Async: Could not copy text: ', err);
                                    });
                                    swal("Copied", "Celeb ID was copied to the clipboard", "success");
                                }}
                                className="w-full hover:scale-105 flex justify-center items-center">
                                <CgCopy size={40} color={"black"} className="bg-white p-2 rounded" />
                            </button>
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Video Link
                            </div>
                        </td>
                        <td className="w-2/4">
                            <a href={reqData["vidSrc"]} className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["vidSrc"]}
                            </a>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Video For
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["videoFor"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>



                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Your Name
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["yourName"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Their Name
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["thierName"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Amount
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["amount"]}₵
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Discount
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["discount"]}₵
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Type
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["type"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Public Video
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["private"]===true?"Yes":"No"}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Message
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["message"]}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Date of Request
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["createdAt"].toDate().getDate().toString()}-{(reqData["createdAt"].toDate().getMonth() + 1).toString()}-{reqData["createdAt"].toDate().getFullYear().toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Due Date
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["expiryDate"].toDate().getDate().toString()}-{(reqData["expiryDate"].toDate().getMonth() + 1).toString()}-{reqData["expiryDate"].toDate().getFullYear().toString()}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>



                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Status
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                <div className="text-md bg-red-500 pl-3 pr-3 pt-1 pb-1 rounded-3xl">
                                    {reqData["status"]}
                                </div>
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>


                    <tr>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Review
                            </div>
                        </td>
                        <td className="w-2/4">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                {reqData["reviewed"] == true ? reqData["review"]["remarks"] : "-"}
                            </div>
                        </td>
                        <td className="w-1/4">
                        </td>
                    </tr>

                </tbody>
            </Table>


        </div>
    )
}